import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import logoLight from "../../assets/images/logo-dark.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import api from "../../utils/api"; // ✅ use central API

const Login = () => {
  const navigate = useNavigate();
  const [passwordShow, setPasswordShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const validation = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),

    onSubmit: async (values, { setErrors }) => {
      try {
        setLoading(true);

        /* ✅ LOGIN API */
        const res = await api.post("/superadmin/login", values);

        const data = res.data;

        /* ✅ STORE AUTH DATA */
        localStorage.setItem("token", data.token);
        localStorage.setItem("tenantId", data.user.tenantId);
        localStorage.setItem("user", JSON.stringify(data.user));
        sessionStorage.setItem("authUser", JSON.stringify(data.user));

        navigate("/dashboard");

      } catch (err) {
        setErrors({
          email: err?.response?.data?.message || "Invalid credentials",
          password: err?.response?.data?.message || "Invalid credentials",
        });
      } finally {
        setLoading(false);
      }
    },
  });

  document.title = "Sign In | RMS";

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content mt-lg-5">
          <Container>

            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={logoLight} alt="" height="50" />
                  </Link>

                  <p className="mt-3 fs-15 fw-medium">
                    Welcome to Nexify RMS (Restaurant Management Service) - Transforming Today for Tomorrow
                  </p>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">

                    <div className="text-center mt-2">
                      <h5 className="text-primary">Welcome Back!</h5>
                      <p className="text-muted">Sign in to continue</p>
                    </div>

                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                        }}
                      >

                        {/* EMAIL */}
                        <div className="mb-3">
                          <Label>Email</Label>
                          <Input
                            name="email"
                            type="email"
                            placeholder="Enter Email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email}
                            invalid={
                              validation.touched.email &&
                              !!validation.errors.email
                            }
                          />
                          <FormFeedback>
                            {validation.errors.email}
                          </FormFeedback>
                        </div>

                        {/* PASSWORD */}
                        <div className="mb-3">
                          <Label>Password</Label>

                          <div className="position-relative">
                            <Input
                              name="password"
                              type={passwordShow ? "text" : "password"}
                              placeholder="Enter Password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.password}
                              invalid={
                                validation.touched.password &&
                                !!validation.errors.password
                              }
                            />

                            <button
                              type="button"
                              className="btn btn-link position-absolute end-0 top-0 text-muted"
                              onClick={() => setPasswordShow(!passwordShow)}
                            >
                              <i className="ri-eye-fill"></i>
                            </button>

                            <FormFeedback>
                              {validation.errors.password}
                            </FormFeedback>
                          </div>
                        </div>

                        {/* LOGIN BUTTON */}
                        <div className="mt-4">
                          <Button
                            color="primary"
                            className="w-100"
                            type="submit"
                            disabled={loading}
                          >
                            {loading ? "Signing In..." : "Sign In"}
                          </Button>
                        </div>

                      </Form>
                    </div>

                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default Login;